import React, { useCallback } from 'react'
import './Contact.scss'
import { useRecoilValue } from 'recoil'
import { langState } from '../../../atoms'
import { getText } from '../../../data/langs'
import { useContactModal } from '../ContactModal/useContactModal'
import AlienDecodeText from '../AlienDecodeText'

const Contact = () => {
  const {value, initialized} = useRecoilValue(langState)
  const text = useCallback((key) => getText(key, value), [value])
  const { openModal } = useContactModal()
  return (
    <div className="Contact">
      <button className="contact-button button" onClick={openModal}><AlienDecodeText text={text('contactme')} autoPlay={initialized}/></button>
      <div className="socials">
        <a href="https://www.linkedin.com/in/marsonlj" target='_blank' className="linkedin"></a>
        <a href='https://github.com/idjitjohn' target='_blank' className="github"></a>
        <a href='https://x.com/MarsonLJ' target='_blank' className="twitter"></a>
      </div>
    </div>
  )
}

export default Contact
